import { render, staticRenderFns } from "./NewReportEntity.vue?vue&type=template&id=8a83cd8e&scoped=true&"
import script from "./NewReportEntity.vue?vue&type=script&lang=js&"
export * from "./NewReportEntity.vue?vue&type=script&lang=js&"
import style0 from "./NewReportEntity.vue?vue&type=style&index=0&id=8a83cd8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83cd8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a83cd8e')) {
      api.createRecord('8a83cd8e', component.options)
    } else {
      api.reload('8a83cd8e', component.options)
    }
    module.hot.accept("./NewReportEntity.vue?vue&type=template&id=8a83cd8e&scoped=true&", function () {
      api.rerender('8a83cd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Entities/NewReportEntity.vue"
export default component.exports